import { render } from "./infoModal.vue?vue&type=template&id=2b027a50&scoped=true"
import script from "./infoModal.vue?vue&type=script&lang=js"
export * from "./infoModal.vue?vue&type=script&lang=js"

import "./infoModal.vue?vue&type=style&index=0&id=2b027a50&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b027a50"]])

export default __exports__